import { render } from "./LogoItem.vue?vue&type=template&id=8ca7db54&scoped=true"
const script = {}

import "./LogoItem.vue?vue&type=style&index=0&id=8ca7db54&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ca7db54"]])

export default __exports__